// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".tableofcontents[data-v-55009b1c]{margin:0}.tableofcontents .toc3[data-v-55009b1c]{margin-left:1em}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
